import React, { useState } from 'react';
import LogOutIcon from '../../static/image/logOutIcon.svg';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logout } from '../../redux/supportportalLoginSlice';
import {
  LEFT_MENU_ADMINISTRATION,
  LEFT_MENU_USER_MANAGEMENT,
  LEFT_MENU_ROLE_AND_PERMISSION,
  LEFT_MENU_MANAGE_RESOURCE,
  LEFT_MENU_MANAGE_PACKAGE,
  LEFT_MENU_MANAGE_PRODUCT,
  LEFT_MENU_MANAGE_CAMPAIGN,
  LEFT_MENU_ORDER_MANAGEMENT,
  LEFT_MENU_VIEW_ORDER,
  LEFT_MENU_VIEW_SALES,
  LEFT_MENU_VIEW_ESIM,
  MENU_IDS
} from '../../utils/constant';
import { decodedJWTPayload } from '../../utils/commonUtil';

function LeftMenu({ title, onSelect, activeMenuItem }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const itemClass = title === LEFT_MENU_ADMINISTRATION ? 'sidebar-item admin-item' : 'sidebar-item';

  const handleLogout = () => {
    dispatch(logout())
      .unwrap()
      .then(() => {
        navigate('/login');
        window.location.reload();
      })
      .catch((error) => {
        console.error('Logout failed:', error);
      });
  };

  const [isExpanded, setIsExpanded] = useState(false);

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  const token = localStorage.getItem('access_token');
  const decodedToken = token ? decodedJWTPayload(token) : null;
  const mnId = decodedToken && decodedToken.mn_id ? decodedToken.mn_id : '';

  const shouldShowMenu = (menuTitle) => {
    switch (menuTitle) {
      case LEFT_MENU_ADMINISTRATION:
        return mnId.includes(MENU_IDS.ADMINISTRATION);
      case LEFT_MENU_MANAGE_RESOURCE:
        return mnId.includes(MENU_IDS.MANAGE_RESOURCE);
      case LEFT_MENU_ORDER_MANAGEMENT:
        return mnId.includes(MENU_IDS.ORDER_MANAGEMENT);
      default:
        return true;
    }
  };

  const toggleSubMenuItems = (title) => {
    switch (title) {
      case LEFT_MENU_ADMINISTRATION: {
        const subMenuItems = [];
        if (mnId.includes(MENU_IDS.USER_MANAGEMENT)) subMenuItems.push(LEFT_MENU_USER_MANAGEMENT);
        if (mnId.includes(MENU_IDS.ROLE_AND_PERMISSION)) subMenuItems.push(LEFT_MENU_ROLE_AND_PERMISSION);
        return subMenuItems;
      }
      case LEFT_MENU_MANAGE_RESOURCE: {
        const subMenuItems = [];
        if (mnId.includes(MENU_IDS.MANAGE_PACKAGE)) subMenuItems.push(LEFT_MENU_MANAGE_PACKAGE);
        if (mnId.includes(MENU_IDS.MANAGE_PRODUCT)) subMenuItems.push(LEFT_MENU_MANAGE_PRODUCT);
        if (mnId.includes(MENU_IDS.MANAGE_CAMPAIGN)) subMenuItems.push(LEFT_MENU_MANAGE_CAMPAIGN);
        return subMenuItems;
      }
      case LEFT_MENU_ORDER_MANAGEMENT: {
        const subMenuItems = [];
        if (mnId.includes(MENU_IDS.VIEW_ORDER)) subMenuItems.push(LEFT_MENU_VIEW_ORDER);
        if (mnId.includes(MENU_IDS.VIEW_SALES)) subMenuItems.push(LEFT_MENU_VIEW_SALES);
        if (mnId.includes(MENU_IDS.VIEW_ESIM)) subMenuItems.push(LEFT_MENU_VIEW_ESIM);
        return subMenuItems;
      }
      default:
        return [];
    }
  };

  const subMenuItems = toggleSubMenuItems(title);

  const getTextStyle = (menuTitle) => {
    if ([LEFT_MENU_ADMINISTRATION, LEFT_MENU_MANAGE_RESOURCE, LEFT_MENU_ORDER_MANAGEMENT].includes(menuTitle)) {
      return {
        color: '#797E85',
        fontSize: '12px',
        fontWeight: 400
      };
    }
    if (activeMenuItem === menuTitle) {
      return {
        color: '#2C2C2C',
        fontSize: '12px',
        fontWeight: 700
      };
    }
    return {
      color: '#797E85',
      fontSize: '12px',
      fontWeight: 400
    };
  };

  if (!shouldShowMenu(title)) {
    return null;
  }

  return (
    <div>
      <div
        className={itemClass}
        onClick={() => {
          if ([LEFT_MENU_ADMINISTRATION, LEFT_MENU_MANAGE_RESOURCE, LEFT_MENU_ORDER_MANAGEMENT].includes(title)) {
            handleToggle();
          } else {
            onSelect(title);
          }
        }}
      >
        <div style={getTextStyle(title)}>{title}</div>
      </div>
      {[LEFT_MENU_ADMINISTRATION, LEFT_MENU_MANAGE_RESOURCE, LEFT_MENU_ORDER_MANAGEMENT].includes(title) && (
        <div className={`sub-menu ${isExpanded ? 'expanded' : 'collapsed'}`}>
          {subMenuItems.map((item, index) => (
            <div
              key={index}
              className={`sub-menu-item ${activeMenuItem === item ? 'active-sub-menu-item' : ''}`}
              onClick={() => {
                onSelect(item);
              }}
            >
              <div style={getTextStyle(item)}>{item}</div>
            </div>
          ))}
        </div>
      )}

      <div className='logout' onClick={handleLogout}>
        <img src={LogOutIcon} alt='' />
        <div style={{ marginLeft: '5px' }}>Log Out</div>
      </div>
    </div>
  );
}

export default LeftMenu;